function Articles() {
  return <div>this is articles</div>;
}

export default Articles;
